import { gql } from '@apollo/client';

export const DueDateFields = gql`
  fragment DueDateFields on DueDateConfiguration {
    type
    fixedType
    fixedDate
    rangeFrom
    rangeTo
    intervalDays
  }
`;

export const CounterOfferFields = gql`
  fragment CounterOfferFields on CampaignOfferCounterProposal {
    id
    createdAt
    message
    originalMessage
    offerId
    proposedAmount
    proposedBy
    proposedByUserId
    proposedInfluencerFee
    proposedPlatformFee
    proposedProcessingFee
  }
`;

export const CampaignSearchLocationFields = gql`
  fragment CampaignSearchLocationFields on CampaignSearchLocation {
    country
    state
    city
    latitude
    longitude
    placeId
    placeText
    radius
  }
`;
